
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../../components/feature/Sidebar';
import Dashboard from './components/Dashboard';
import Clients from './components/Clients';
import Pipeline from './components/Pipeline';
import Users from './components/Users';
import Settings from './components/Settings';
import Planning from './components/Planning';
import SuperAdmin from './components/SuperAdmin';

export default function CRM() {
  const [currentPage, setCurrentPage] = useState('dashboard');
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    // Vérifier si l'utilisateur est connecté
    const storedUser = localStorage.getItem('currentUser');
    if (storedUser) {
      setCurrentUser(JSON.parse(storedUser));
    } else {
      // Rediriger vers la page de connexion si pas connecté
      navigate('/login');
    }
    setLoading(false);
  }, [navigate]);

  const handleLogout = () => {
    localStorage.removeItem('currentUser');
    navigate('/login');
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
        <div className="text-center">
          <i className="ri-loader-4-line text-4xl text-blue-600 animate-spin mb-4"></i>
          <p className="text-gray-600">Chargement...</p>
        </div>
      </div>
    );
  }

  if (!currentUser) {
    return null; // Utilisateur sera redirigé vers /login
  }

  const renderPage = () => {
    // Si l'utilisateur est Super Admin, afficher le panneau spécial
    if (currentUser.role === 'super_admin') {
      switch (currentPage) {
        case 'dashboard':
          return <SuperAdmin />;
        case 'companies':
          return <SuperAdmin />;
        default:
          return <SuperAdmin />;
      }
    }

    // Pour les autres utilisateurs
    switch (currentPage) {
      case 'dashboard':
        return <Dashboard currentUser={currentUser} />;
      case 'clients':
        return <Clients currentUser={currentUser} />;
      case 'pipeline':
        return <Pipeline currentUser={currentUser} />;
      case 'planning':
        return <Planning currentUser={currentUser} />;
      case 'users':
        return currentUser.role === 'admin' ? <Users /> : <Dashboard currentUser={currentUser} />;
      case 'settings':
        return currentUser.role === 'admin' ? <Settings /> : <Dashboard currentUser={currentUser} />;
      default:
        return <Dashboard currentUser={currentUser} />;
    }
  };

  return (
    <div className="flex flex-col lg:flex-row h-screen bg-gray-50">
      <Sidebar 
        currentUser={currentUser}
        currentPage={currentPage}
        onNavigate={setCurrentPage}
        onLogout={handleLogout}
      />
      <main className="flex-1 overflow-auto bg-gray-50">
        <div className="min-h-full">
          {renderPage()}
        </div>
      </main>
    </div>
  );
}
